import React from "react";
import { Box, Grid2, List, ListItem, ListItemText, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { CiYoutube } from "react-icons/ci";
import { FaInstagram, FaFacebook } from "react-icons/fa";
import { AiFillAndroid, AiFillApple } from "react-icons/ai";
import { Constants, Page_Padding } from "../shared/constants";
import { useFooter } from "../assets/api/useGetApi";
import { TextSkeleton } from "../shared/utils/SkeletonCom";
import useResponsive from "../shared/utils/Responsive";

const iconStyle = {
    fontSize: "20px",
    color: "#DC143C",
};

export const proSkillUrl="https://myskill.club/pro/"
const FooterList = ({ title, items }) => (
    <Box>
        <Typography variant="body1" fontSize={"20px"} gutterBottom>
            {title}
        </Typography>
        <List sx={{ p: 0 }}>
            {items.map(({ name, path, icon }, index) => (
                <ListItem sx={{ py: 0.1, display: "flex", alignItems: "center", pl: "0" }} key={index}>
                    <Link 
                    to={path} style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center", gap: "10px" }}
                    target={path === proSkillUrl ? "_blank" : "_self"} 
                    rel={path === proSkillUrl ? "noopener noreferrer" : ""}
                    >
                        {icon && <Box sx={{ display: "flex", alignItems: "center" }}>{icon}</Box>}
                        <ListItemText primary={<Typography variant="body2" color="grey.100">{name}</Typography>} />
                    </Link>
                </ListItem>
            ))}
        </List>
    </Box>
);

const Footer = () => {
    const { data: footer, isLoading } = useFooter();
    const isSmallScreen = useResponsive("md")
    const QuickLinks = [
        { name: "Home", path: "/" },
        { name: "About Us", path: "/About" },
        { name: "Courses", path: "/Courses" },
        { name: "My Skill Pro", path:proSkillUrl }, 
        { name: "Events", path: "/Events" },
        { name: "On Boarding", path: "/Apartmentonboarding" },
        { name: "FAQ", path: "/Faq" },
        { name: "Contact Us", path: "/ContactUs" },
    ];

    const ConnectInfo = [
        { name: "YouTube", icon: <CiYoutube style={iconStyle} />, path: "#" },
        { name: "Instagram", icon: <FaInstagram style={iconStyle} />, path: "#" },
        { name: "Facebook", icon: <FaFacebook style={iconStyle} />, path: "#" },
    ];

    const LegalList = [
        { name: "Terms & Conditions", path: "#" },
        { name: "Privacy Policy", path: "#" },
    ];

    return (
        <Grid2 container component="footer" sx={{ py: "45px", px: Page_Padding, bgcolor: "primary.light" }} spacing={5} >
            {!isSmallScreen && <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                <img src={Constants.customImages.Logo} width={"200px"} height={"70px"} />
                {
                    !isLoading && (
                        <Typography variant="body2" sx={{ color: "grey.100", lineHeight: "22px", mt: 2 }}>
                            {footer?.data?.site_description}
                        </Typography>
                    )
                }
                {isLoading && (
                    <TextSkeleton />
                )
                }
            </Grid2>}

            <Grid2 children size={{ xs: 12, sm: isSmallScreen ? 4 : 3 }}>
                <FooterList title="Quick Links" items={QuickLinks} />
            </Grid2>

            <Grid2 children size={{ xs: 12, sm: isSmallScreen ? 4 : 2.5 }}>
                <FooterList title="Connect With Us" items={ConnectInfo} />
                <Typography variant="body1" fontSize={"20px"} mt={5} gutterBottom>
                    Available On
                </Typography>
                <Box display="flex" gap={2}>
                    <AiFillAndroid style={{
                        fontSize: "40px",
                        color: "#DC143C",
                    }} />
                    <AiFillApple style={{
                        fontSize: "40px",
                        color: "#DC143C",
                    }} />
                </Box>
            </Grid2>

            <Grid2 children size={{ xs: 12, sm: isSmallScreen ? 4 : 2.5 }}>
                <FooterList title="Legal" items={LegalList} />
            </Grid2>
            <Grid2 children size={12}>
                <Typography variant="body2" color="text.secondary" textAlign={"center"}>Copyrights of the website @MySkill.club</Typography>
            </Grid2>
        </Grid2>
    );
};

export default Footer;
